import type { EChartsOption } from 'echarts';

export const CHART_COLORS = [
  '#A2E2E6',
  '#C8E6A2',
  '#94A5FE',
  '#FEAAAA',
  '#1093F5',
  '#0D36A1',
  '#FFA500',
  '#9038A7',
  '#0FBA97',
  '#BD11E0',
  '#76C0D7',
  '#F63F2C',
  '#46B04A',
  '#2778BF',
  '#7EA0A7',
  '#FEB085',
  '#C7C6F8',
  '#FE9E69',
  '#E59CB9',
  '#CD8086',
];

export const DEFAULT_OPTIONS: EChartsOption = {
  color: CHART_COLORS,
  grid: {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
  },
  xAxis: {
    axisTick: { show: false },
    axisLabel: {
      fontSize: 14,
      color: '#000000E0',
      fontWeight: 600,
      lineHeight: 16,
      overflow: 'break',
      interval: 0,
    },
    axisLine: { lineStyle: { color: '#ddd' } },
  },
  yAxis: {
    axisTick: { show: false },
    axisLabel: {
      fontSize: 12,
      color: '#00000073',
      fontWeight: 400,
    },
    axisLine: { show: false },
    splitLine: { lineStyle: { color: '#eee' } },
  },
};
